import { atom } from "recoil";
type LanguageCode = 'EN' | 'BM';

export interface LanguageSettingType {
  site: 'DHSN' | 'DEM' | 'P2U' | 'ESP' | 'HHP';
  defaultLanguage: string;
  otherLanguages: string[];
}


export interface LanguageSettingObject {
  _id: string;
  languageSetting: LanguageSettingType[];
}

export const languageSettingListStateAtom = atom<LanguageSettingObject|undefined>({
  key: 'setting/languageSettingListState',
  default: undefined,
});